var map = {
	"./": "PQJH",
	"./CategoryHeaderVariant1": "mT6x",
	"./CategoryHeaderVariant1.jsx": "mT6x",
	"./CategoryHeaderVariant2": "QxfT",
	"./CategoryHeaderVariant2.jsx": "QxfT",
	"./CategoryHeaderVariant3": "f8/a",
	"./CategoryHeaderVariant3.jsx": "f8/a",
	"./CategoryHeaderVariant4": "O1XJ",
	"./CategoryHeaderVariant4.jsx": "O1XJ",
	"./_stories": "+leA",
	"./_stories.js": "+leA",
	"./index": "PQJH",
	"./index.jsx": "PQJH"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	if(!__webpack_require__.m[id]) {
		var e = new Error("Module '" + req + "' ('" + id + "') is not available (weak dependency)");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
webpackContext.id = "QlLJ";
module.exports = webpackContext;